.operationCertificate {
  border: 1px black solid;
  border-radius: 4px;
  padding: 6px 12px;
  display: flex;
  font-size: 12px;
  align-items: center;
  margin-bottom: 1em;
}

.operationCertificates {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
}
